import { combineReducers } from 'redux'
import authData from './authData'
import apps from './apps'
import plans from './plans'
import references from './references'
import user from './user'
import location from './location'
import gui from './gui'
import integrationProducts from './integrationProducts'
import lastApp from './lastApp'
import shopifyAppData from './shopifyAppData'
import shopifyAuth from './shopifyAuth'
import shopifyAnalytics from './shopifyAnalytics'
import shopifyPlans from './shopifyPlans'

const rootReducer = combineReducers({
  authData,
  apps,
  plans,
  references,
  user,
  location,
  gui,
  integrationProducts,
  lastApp,
  shopifyAppData,
  shopifyAuth,
  shopifyAnalytics,
  shopifyPlans
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js